'use strict';

var FaresOptimizerStatusDetailsDirective = function FaresOptimizerStatusDetailsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-status-details-modal.html'),
    controller: 'FaresOptimizerStatusDetailsModalController',
    link: function link($scope, $element) {
      $scope.$watch('statusDetails.showPopup', function (newVal) {
        if (newVal) {
          $scope.handleStatusDetails();
          $element.modal('show');
          $scope.statusDetails.showPopup = false;
        }
      });
    }
  };
};
FaresOptimizerStatusDetailsDirective.$inject = [];
module.exports = FaresOptimizerStatusDetailsDirective;